import { AnyAction } from 'redux';

interface LastUrlState {
    lastUrl: object|null
}

const noLastUrl : LastUrlState = {
    'lastUrl': null
};

const lastUrl = (state = noLastUrl, action: AnyAction) => {
    switch (action.type) {
        case 'SET_LAST_URL':
          
            const newState = {
                lastUrl: action.lastUrl,
            }

            return {
                ...state,
                ...newState
            }
            
        default:
            return state
    }
}
  
export default lastUrl;